var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgC11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.43,121.45s-25.16-50.36-80.71-57.82-94.33,28.91-135.21,47.56c-21.4,9.77-45.85,6-68.58,10.71C62.27,137,34.89,231.72,65.16,285.59c26.2,46.63,72.32,70.87,142.55,76.47s119.48,12.12,182.37-33.57S448.78,187.67,419.43,121.45Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.43,121.45s-25.16-50.36-80.71-57.82-94.33,28.91-135.21,47.56c-21.4,9.77-45.85,6-68.58,10.71C62.27,137,34.89,231.72,65.16,285.59c26.2,46.63,72.32,70.87,142.55,76.47s119.48,12.12,182.37-33.57S448.78,187.67,419.43,121.45Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.01,
    y: 140.1,
    width: 263.85,
    height: 113.19,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.84,
    y: 136.91,
    width: 278.2,
    height: 4.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.01,
    y: 249.3,
    width: 263.85,
    height: 3.99,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.85,
    cy: 178.54,
    r: 18.11,
    transform: "translate(-4.82 351.36) rotate(-80.3)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.52,
    y1: 155.16,
    x2: 205.52,
    y2: 206.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.81,
    y1: 178.87,
    x2: 228.57,
    y2: 178.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.53,
    y1: 183.27,
    x2: 326.29,
    y2: 183.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302.58,
    y1: 158.91,
    x2: 302.58,
    y2: 210.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.46,165.49l7.1,5.52a17.82,17.82,0,0,0,21.56.25l6.91-5.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,198.63l-7.1-5.52a17.85,17.85,0,0,0-21.57-.25l-6.9,5.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.47,
    y1: 158.41,
    x2: 386.47,
    y2: 201.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.3,
    y1: 180.29,
    x2: 407.08,
    y2: 180.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 366.11,
    y1: 178.57,
    x2: 366.11,
    y2: 182.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.65,
    y1: 178.57,
    x2: 368.65,
    y2: 182.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.2,
    y1: 178.57,
    x2: 371.2,
    y2: 182.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 373.74,
    y1: 178.57,
    x2: 373.74,
    y2: 182.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 376.29,
    y1: 178.57,
    x2: 376.29,
    y2: 182.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 378.83,
    y1: 178.57,
    x2: 378.83,
    y2: 182.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 381.37,
    y1: 178.57,
    x2: 381.37,
    y2: 182.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383.92,
    y1: 178.57,
    x2: 383.92,
    y2: 182.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389,
    y1: 178.57,
    x2: 389,
    y2: 182.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 391.55,
    y1: 178.57,
    x2: 391.55,
    y2: 182.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 394.09,
    y1: 178.57,
    x2: 394.09,
    y2: 182.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 396.64,
    y1: 178.57,
    x2: 396.64,
    y2: 182.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 399.18,
    y1: 178.57,
    x2: 399.18,
    y2: 182.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 401.72,
    y1: 178.57,
    x2: 401.72,
    y2: 182.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404.27,
    y1: 178.57,
    x2: 404.27,
    y2: 182.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.72,
    y1: 199.4,
    x2: 388.22,
    y2: 199.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.72,
    y1: 196.85,
    x2: 388.22,
    y2: 196.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.72,
    y1: 194.31,
    x2: 388.22,
    y2: 194.31,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.72,
    y1: 191.76,
    x2: 388.22,
    y2: 191.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.72,
    y1: 189.22,
    x2: 388.22,
    y2: 189.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.72,
    y1: 186.68,
    x2: 388.22,
    y2: 186.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.72,
    y1: 184.13,
    x2: 388.22,
    y2: 184.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.72,
    y1: 176.5,
    x2: 388.22,
    y2: 176.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.72,
    y1: 173.96,
    x2: 388.22,
    y2: 173.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.72,
    y1: 171.41,
    x2: 388.22,
    y2: 171.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.72,
    y1: 168.87,
    x2: 388.22,
    y2: 168.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.72,
    y1: 166.33,
    x2: 388.22,
    y2: 166.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.72,
    y1: 163.78,
    x2: 388.22,
    y2: 163.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.72,
    y1: 161.24,
    x2: 388.22,
    y2: 161.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.98,
    y1: 217,
    x2: 224.92,
    y2: 217,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.98,
    y1: 221.92,
    x2: 224.92,
    y2: 221.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.98,
    y1: 226.84,
    x2: 224.92,
    y2: 226.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.98,
    y1: 231.77,
    x2: 224.92,
    y2: 231.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 286.19,
    y1: 217,
    x2: 326.13,
    y2: 217,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 286.19,
    y1: 221.92,
    x2: 326.13,
    y2: 221.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 286.19,
    y1: 226.84,
    x2: 326.13,
    y2: 226.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 286.19,
    y1: 231.77,
    x2: 326.13,
    y2: 231.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.8,
    y1: 217,
    x2: 408.74,
    y2: 217,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.8,
    y1: 221.92,
    x2: 408.74,
    y2: 221.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.8,
    y1: 226.84,
    x2: 408.74,
    y2: 226.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.8,
    y1: 231.77,
    x2: 408.74,
    y2: 231.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.77,
    y1: 190.74,
    x2: 274.7,
    y2: 190.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.77,
    y1: 195.66,
    x2: 274.7,
    y2: 195.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.77,
    y1: 200.58,
    x2: 274.7,
    y2: 200.58,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.77,
    y1: 205.51,
    x2: 274.7,
    y2: 205.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 324.49,
    y1: 154.08,
    x2: 364.42,
    y2: 154.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 324.49,
    y1: 159.01,
    x2: 364.42,
    y2: 159.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 324.49,
    y1: 163.93,
    x2: 364.42,
    y2: 163.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 324.49,
    y1: 168.85,
    x2: 364.42,
    y2: 168.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--table-3--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.05,
    y: 253,
    width: 51.51,
    height: 43.27,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.31,
    y: 301.77,
    width: 51.51,
    height: 2.75,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.29,
    y: 284.25,
    width: 9.96,
    height: 19.92,
    style: {
      fill: "#707070",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.22,
    y: 308.45,
    width: 137.37,
    height: 91.39,
    style: {
      fill: "#707070",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.84,
    y: 309.11,
    width: 4.63,
    height: 92.89,
    style: {
      fill: "#707070",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.83,
    y: 309.11,
    width: 4.63,
    height: 92.89,
    style: {
      fill: "#707070",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.97,
    y: 303.57,
    width: 152,
    height: 8.73,
    style: {
      fill: "#707070",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.64,219.06s-5.52,3.43-7.31,7.91-9.25,27.63-11.19,30.62-1.94,7.61.3,10.15,6,4.17,9.1,1.19,4-8.95,7-16,5.53-26.89,7-30.92a31.89,31.89,0,0,0,1.79-7.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.71,277.28s.89,11.87.44,17.91-4.47,44.14-4.47,44.14l-5.82,51.4h-8.95l-6.5-75.8-8.72,75.58h-9.18s-5.37-47.6-6.94-59A107.87,107.87,0,0,1,245.9,310c0-.67-2-15.89-2-20.14a74.11,74.11,0,0,1,.6-8.66l-.37-1.64s16.56,4.48,28,1.79,22.6-6.26,22.6-6.26Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.86,390.73l2.68,9.18a1.27,1.27,0,0,1-.44,1.79c-1.12.67-13.66,0-13.66,0a1.75,1.75,0,0,1-.89-2c.22-1.57,3.36-9,3.36-9Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.69,390.51l.81,8.37a2.2,2.2,0,0,1-.39,1.47h0a2.16,2.16,0,0,1-1.76.9H244c-1.76,0-5.16-.06-4.83-1.79v0c.22-1.12,14.32-8.92,14.32-8.92Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "271.41 314.93 269.18 305.49 261.12 299.89",
    style: {
      fill: "none",
      stroke: "#6b6b6b",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.51,230.55V248c0,1-5.37,24-5.82,26.26s0,4.33,1.79,6.86,8.51,5.08,23.13,6.27,25.52-4.18,28.5-7.61-.45-10-1.49-19.25S293.27,222,289.1,220.1s-17.61-8.35-17.61-8.35-7.61,0-12.68,2.24a26,26,0,0,0-8.66,6.71",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.59,208.76a4,4,0,0,1,4,2.39c1.05,2.69-2.24,18.95-2.24,18.95s-7.31-5.22-9.1-5.22-10,5.22-10,5.22,2.69-11.19,5.08-15.52,8.95-6.71,11.64-6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.19,207.27s.6,1.49-2.09,8.66-4,13.28-5.67,11.63-3.58-10.29-3.58-10.29S268.5,211,271.19,207.27Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.19,195.71A120.19,120.19,0,0,0,250.11,208c1.45,4.36,3.32,10.81,8.31,12.26s6.45-2.28,8.53-4,5.4-7.28,5.4-10-.21-8.73-1.25-10.81-2.91-4.16-8.31-5.2S252.39,190.09,247.19,195.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.69,201.32s-3.12,1.25-3.95-.62-2.29-4.58-2.29-4.58S258,198.83,254.06,199s-8.32-2.28-8.94-5,1.66-8.73,6.86-12,16-4.79,19.33.41a22.79,22.79,0,0,1,3.54,13.31c0,3.53-.21,6-.21,6A4.8,4.8,0,0,0,270.69,201.32Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.44,202.78s1.87-4.79,3.74-4.16,2.08,4.37,1,6.65-3.74,3.12-4.36,2.71",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.46,205.31s7.52-.53,9.11-.32,1.37,2,.95,4-2.86,3.18-5.72,2.65-3.5-3-4-3.39-.74-.85-1.37-.53-.53,2.54-1.27,3.49-2.76,1.7-5,.53-2.12-4.55-2.12-5.72,1.16-1.06,1.69-1S255.46,205.31,255.46,205.31Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 265.63,
    y1: 205.42,
    x2: 270.29,
    y2: 200.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.56,
    y1: 204.99,
    x2: 248.36,
    y2: 202.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.29,208.91s-.42,1.27-.64,2.33.64,3.18,1.91,3,1.59-.85,1.59-.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,203.83a6.37,6.37,0,0,0-4.35.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.23,204.25a2.78,2.78,0,0,0-3.39-.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.77,218.31s6.42,1.94,9.25,4.33,7.4,21.16,8.74,30.11,3.43,16.69,1.64,17.74-29.78-2.61-29.78-2.61l-.89-4.32,18.24-3.8s-10.19-20-10.48-25.48a19.26,19.26,0,0,1,1.19-8.65",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.93 253.26 262.83 272.66 249.41 277.58 241.05 258.78 254.93 253.26",
    style: {
      fill: "#D175F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.05 258.78 231.5 251.77 240 271.47 249.41 277.58 241.05 258.78",
    style: {
      fill: "#D175F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.73,263.56s-10.75-3-11.94-3.88-11.19,3.13-11.79,3.13-.45.75.15,1.05,7.16-1.5,7.16-1.5-6.26,3.29-6.26,4a1.63,1.63,0,0,0,.59,1.2s.15,1.34.9,1.64,8.35-1.2,8.35-1.2-6,2.24-5.22,2.69a2.28,2.28,0,0,0,2.39,0c.89-.45,6.27-2.09,6.27-2.09s4,1.19,6.26.6a35.22,35.22,0,0,0,4-1.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 251.64,
    y1: 267.59,
    x2: 259.1,
    y2: 265.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.14,257.59s5.07,3.73,6,4.92a3.07,3.07,0,0,1,.6,2.39l-3.29-1.34s4.18,3.73,4.33,4.32,1.64,3.14-.15,2.84-7.16-3.13-8.21-4.63-1.34-8.5-1.34-8.5S231.5,256.1,233.14,257.59Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.75,
    y1: 268.78,
    x2: 234.78,
    y2: 265.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.35,270.12s-5.37-2.38-6.42-3.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.42,
    y1: 263.56,
    x2: 234.63,
    y2: 262.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--table-2--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 269.09,
    y: 317.46,
    width: 4.16,
    height: 84.54,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.99,
    y: 317.46,
    width: 4.16,
    height: 84.54,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.61,
    y: 312.47,
    width: 203.39,
    height: 7.85,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--table-1--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.87,
    y: 317.46,
    width: 4.16,
    height: 84.54,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.76,
    y: 317.46,
    width: 4.16,
    height: 84.54,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.39,
    y: 312.47,
    width: 203.39,
    height: 7.85,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-5--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "401.8 332.28 411.36 393.53 416.48 393.85 417.69 333.78 401.8 332.28",
    style: {
      fill: "#707070",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.36,393.53l0,6.82a1.09,1.09,0,0,0,1,1.08l3.75.21a1.08,1.08,0,0,0,1.13-1.21l-.76-6.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.15 332.43 428.54 393.47 423.41 393.67 423.24 333.59 439.15 332.43",
    style: {
      fill: "#707070",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.54,393.47l-.12,6.81a1.08,1.08,0,0,1-1.05,1.06l-3.76.13a1.08,1.08,0,0,1-1.1-1.23l.9-6.57Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.78,273.09s-16,31-16.44,33.64,2.18,6.55,6.76,6.11,16.51-.65,16.51-.65l.22-4.15-13.75-1.74,8.29-6.55Z",
    style: {
      fill: "#D175F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392.08,
    y1: 306.3,
    x2: 390.41,
    y2: 309.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.63,273.76s16.3,30.35,16.74,33-2.18,6.55-6.76,6.11-15.29-.65-15.29-.65L436.1,308l7.44-1.74-5.21-6.63Z",
    style: {
      fill: "#D175F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 443.54,
    y1: 306.3,
    x2: 450.3,
    y2: 309.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,264.92l-10.5,5.56c-5.25,2.78-4.4,1.22-4.71,2.61s1.77,49.57,1.77,49.57,4,3.9,14.52,4.94c15.74,1.54,22.53-3.4,22.53-3.4s4-48.74,4-50.44-6.5-5-10.66-7S422.17,263.07,414,264.92Z",
    style: {
      fill: "#D175F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.6,232s-6.81,3-9,7.89,1.36,16.33.54,19.32-4.62,2.72-4.62,2.72,1.63,9.26,10.88,10.35,13.34-.28,17.15-4.36,3-4.08,3-4.08-1.63,0-2.45-4.63.27-17.69-3.81-23.4S421,230.32,419.6,232Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.55,322.66s-1.38,15.43-.92,17.44,5.25,5.25,15,5.56,21.92.77,24.86-2.78-1.86-18.68-1.86-18.68S411.67,326.36,400.55,322.66Z",
    style: {
      fill: "#707070",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.09,264.63s.23-1.6,5-.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.33,401.07h0a1.08,1.08,0,0,1-1-1.17l3.17-58.37,3.64.29-4.66,58.26A1.08,1.08,0,0,1,400.33,401.07Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.58,401.07h0a1.09,1.09,0,0,0,1-1.17l-3.17-58.37-3.64.29,4.65,58.26A1.09,1.09,0,0,0,439.58,401.07Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.31,295.58a176.59,176.59,0,0,1-24.59,1.81,171.08,171.08,0,0,1-23-1.81,1.86,1.86,0,0,0-2.13,2.12c1.18,7.38,4.53,28.61,4.53,32.67,0,4.94-1.7,9.58-1.7,11.74s.93,3.86,2.47,4.47c.72.29,8.81.31,19.75.25,12.66.06,20.76,0,21.47-.25,1.54-.61,2.47-2.31,2.47-4.47s-1.7-6.8-1.7-11.74c0-4.06,3.35-25.3,4.54-32.67A1.85,1.85,0,0,0,443.31,295.58Zm-7.92,45.23c-.55.21-6.79.23-16.55.18-8.43.05-14.67,0-15.22-.18a3.45,3.45,0,0,1-1.9-3.42c0-1.65,1.3-5.19,1.3-9,0-.88-.21-2.84-.53-5.32l3.09,3.35a4.53,4.53,0,0,0,3.31,1.44h21.2a4.51,4.51,0,0,0,3.15-1.28l3.23-3.15c-.3,2.31-.49,4.12-.49,5,0,3.77,1.31,7.31,1.31,9A3.45,3.45,0,0,1,435.39,340.81Zm4.09-37.31c-.52,3.2-1.58,9.81-2.4,15.49L434,320.9a11,11,0,0,1-5.73,1.6H411a11,11,0,0,1-5.58-1.52l-3.51-2.06c-.81-5.67-1.86-12.24-2.38-15.42a1.43,1.43,0,0,1,1.64-1.62,132.59,132.59,0,0,0,17.73,1.38,136.71,136.71,0,0,0,19-1.38A1.42,1.42,0,0,1,439.48,303.5Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "322.28 277.52 322.28 269.19 334.17 269.19 334.17 278.14 322.28 277.52",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.42,258.54s-1.86-.47-1.86,2.47S317,266,318,265.79s-.46-5.71-.62-6.79S316.42,258.54,316.42,258.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.58,258.54s1.85-.47,1.85,2.47S339,266,338,265.79s.46-5.71.61-6.79S339.58,258.54,339.58,258.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.62,246.91s1.16-.58-.14-3.34a5.67,5.67,0,0,0-3.77-3.19s1-.58,1-1.16-1.3-.72-5.22.44a5.1,5.1,0,0,0-4,4.52,1.59,1.59,0,0,0-.23-.11c-.95-.46-4.63-2.1-6.39-1.22-2,1,.29.72.29.72a9.15,9.15,0,0,0-5.8,3.48c-2.17,3-.58,3.34-.14,3.34s.87-1.31.87-1.31v2.76s.05.24.14.62c-.61,4.09.47,8.72,1.07,11.63.77,3.71,3.86,7.26,6.18,8s9.41,0,9.41,0a26.68,26.68,0,0,0,4.48-6,20.82,20.82,0,0,0,2-8.7,14.3,14.3,0,0,0,1.37-5.27C341.07,248.36,339.62,246.91,339.62,246.91Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.87,262.61s-6.55-3.53-13-.77c-3.73,1.59-6.48,5.55-6.48,5.55a36.94,36.94,0,0,1,10-1.54,122.64,122.64,0,0,1,12.5.92A14,14,0,0,0,335.87,262.61Z",
    style: {
      fill: "#D175F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.06,277.27s-17,26.84-17.44,29.46,2.18,6.55,6.76,6.11,21.6-.65,21.6-.65l.22-4.15-13.74-1.74,8.29-6.55Z",
    style: {
      fill: "#D175F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 299.46,
    y1: 306.3,
    x2: 292.69,
    y2: 309.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.39,276.19s17.23,27.92,17.66,30.54-2.18,6.55-6.76,6.11-21.6-.65-21.6-.65l-.22-4.15,13.75-1.74-8.29-6.55Z",
    style: {
      fill: "#D175F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.22,
    y1: 306.3,
    x2: 363.98,
    y2: 309.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.36,264.92l-10.5,5.56c-5.25,2.78-8.49,5.4-8.8,6.79s5.87,45.39,5.87,45.39,4,3.9,14.51,4.94c15.74,1.54,22.53-3.4,22.53-3.4s9.42-46.31,9.42-48-11.89-7.41-16.05-9.42S329.54,263.07,321.36,264.92Z",
    style: {
      fill: "#D175F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.97 335.47 317.34 394.18 322.44 393.56 314.87 334.08 298.97 335.47",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.34,394.18l1.21,6.71a1.08,1.08,0,0,0,1.2.88l3.73-.48a1.08,1.08,0,0,0,.9-1.39l-1.94-6.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.61 335.47 337.24 394.18 332.14 393.56 339.71 334.08 355.61 335.47",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.24,394.18,336,400.89a1.08,1.08,0,0,1-1.2.88l-3.73-.48a1.08,1.08,0,0,1-.9-1.39l1.94-6.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.67,328.52s-16.82-5.25-19.91-3.7-6.18,5.55-5.1,10,10.35,9.88,12.35,10,12.82,0,12.82,0Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.94,328.52s16.83-5.25,19.92-3.7,6.17,5.55,5.09,10-10.34,9.88-12.35,10-12.81,0-12.81,0Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.93,322.66s-1.39,15.43-.93,17.44,5.25,5.25,15,5.56,21.92.77,24.86-2.78S345,324.2,345,324.2,319,326.36,307.93,322.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.7,401.07h0a1.09,1.09,0,0,1-1-1.17l3.17-58.37,3.64.29-4.65,58.26A1.09,1.09,0,0,1,307.7,401.07Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,401.07h0a1.09,1.09,0,0,0,1-1.17l-3.17-58.37-3.64.29,4.65,58.26A1.09,1.09,0,0,0,347,401.07Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.64,295.58a176.59,176.59,0,0,1-24.59,1.81,171.34,171.34,0,0,1-23-1.81,1.86,1.86,0,0,0-2.13,2.12c1.19,7.38,4.54,28.61,4.54,32.67,0,4.94-1.7,9.58-1.7,11.74s.92,3.86,2.47,4.47c.71.29,8.8.31,19.74.25,12.67.06,20.76,0,21.47-.25,1.55-.61,2.47-2.31,2.47-4.47s-1.69-6.8-1.69-11.74c0-4.06,3.35-25.3,4.53-32.67A1.85,1.85,0,0,0,350.64,295.58Zm-7.92,45.23c-.55.21-6.79.23-16.55.18-8.43.05-14.67,0-15.22-.18a3.45,3.45,0,0,1-1.9-3.42c0-1.65,1.31-5.19,1.31-9,0-.88-.21-2.84-.54-5.32l3.1,3.35a4.5,4.5,0,0,0,3.31,1.44h21.2a4.54,4.54,0,0,0,3.15-1.28l3.22-3.15c-.29,2.31-.48,4.12-.48,5,0,3.77,1.3,7.31,1.3,9A3.45,3.45,0,0,1,342.72,340.81Zm4.09-37.31c-.52,3.2-1.58,9.81-2.39,15.49l-3.14,1.91a11,11,0,0,1-5.72,1.6H318.34a11,11,0,0,1-5.59-1.52l-3.5-2.06c-.82-5.67-1.87-12.24-2.39-15.42a1.43,1.43,0,0,1,1.64-1.62,132.59,132.59,0,0,0,17.73,1.38,136.59,136.59,0,0,0,18.95-1.38A1.42,1.42,0,0,1,346.81,303.5Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.38 295.87 316.31 317.96 320.93 317.3 315.98 296.86 310.38 295.87",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.79 316.64 338.08 296.86 344.02 296.19 338.41 317.96 333.79 316.64",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.82 331.87 312.69 348.3 312.69 355.56 304.11 337.75 304.82 331.87",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.97 331.87 341.11 348.3 341.11 355.56 349.68 337.75 348.97 331.87",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.25,312.36s-14.18-1-18.47.33-6.59,4.61-6.26,9.89-2.64,25.72-2.31,31,2.31,8.58,10.88,10.23,17.48,1,22.43-1,7.31-9.54,4.28-17.48-2.27-20.15-3.59-26.08S337.56,312.69,335.25,312.36Z",
    style: {
      fill: "#D175F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.25,352.12c0,.12-.23,3.27-.26,3.39-2.32,8.81-14.75,7.41-21.64,6.26-3.43-.57-8.57-2.3-9.9-6-1.45-4,.43-9,1.15-13.05.44-2.51.69-10.2,3.53-11.48s20.08-3.13,22.69,2.08C341.74,339.18,342.21,345.34,343.25,352.12Z",
    style: {
      fill: "#D175F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.69,
    y: 318.47,
    width: 6.52,
    height: 3.65,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.52,343h28.17a4.26,4.26,0,0,1-3.39,4.44c-4.21.9-8.85.73-13.12.74C321.35,348.17,313.08,348.74,313.52,343Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "188.57 332.64 198.13 393.9 203.25 394.21 204.46 334.15 188.57 332.64",
    style: {
      fill: "#D175F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.13,393.9l0,6.81a1.09,1.09,0,0,0,1,1.09l3.76.2a1.09,1.09,0,0,0,1.13-1.21l-.76-6.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.93 332.79 215.31 393.83 210.19 394.03 210.01 333.96 225.93 332.79",
    style: {
      fill: "#D175F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.31,393.83l-.12,6.81a1.09,1.09,0,0,1-1,1.07l-3.76.12a1.09,1.09,0,0,1-1.11-1.23l.9-6.57Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.56,273.45s-16,31-16.45,33.64,2.19,6.55,6.77,6.11,16.5-.65,16.5-.65l.22-4.15-13.74-1.74,8.29-6.55Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 178.86,
    y1: 306.66,
    x2: 177.19,
    y2: 309.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.59,272.78s16.12,31.7,16.55,34.31-2.18,6.55-6.76,6.11-15.28-.65-15.28-.65l-.22-4.15,7.43-1.74-4.69-6.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230.31,
    y1: 306.66,
    x2: 237.07,
    y2: 309.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.76,265.29l-10.5,5.55c-5.25,2.78-4.4,1.22-4.7,2.61S187.33,323,187.33,323s4,3.91,14.51,4.94c15.75,1.54,22.54-3.4,22.54-3.4s4-48.74,4-50.44-6.5-5-10.67-7S208.94,263.43,200.76,265.29Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.33,323s-1.39,15.44-.93,17.44,5.25,5.25,15,5.56,21.92.77,24.85-2.78-1.85-18.68-1.85-18.68S198.44,326.72,187.33,323Z",
    style: {
      fill: "#D175F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,235.06s-5-3-10.28,2.74.23,17.14.91,19.88S189.5,276,189.5,283,198,297,211.44,295.61s15.08-8.46,13.25-16.91-3.89-17.37-3.89-21,3.2-11.88.23-19.88S210.75,232.09,208,235.06Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.7,259.05l6.17,5.94s-6.4,15.31-7.09,19.42,3,8,8,7.54,8.23-4.8,8-8.45-3.89-18.74-3.89-18.74a20.62,20.62,0,0,0,7.77-7.08",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.87,265s.23-1.6,5-.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.1,401.43h0a1.09,1.09,0,0,1-1-1.16l3.17-58.38,3.64.3-4.65,58.25A1.08,1.08,0,0,1,187.1,401.43Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.35,401.43h0a1.08,1.08,0,0,0,1-1.16l-3.16-58.38-3.64.3,4.65,58.25A1.08,1.08,0,0,0,226.35,401.43Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.08,295.94a176.56,176.56,0,0,1-24.58,1.81,169.73,169.73,0,0,1-23-1.81,1.86,1.86,0,0,0-2.12,2.13c1.18,7.37,4.53,28.6,4.53,32.67,0,4.94-1.7,9.57-1.7,11.73s.93,3.86,2.47,4.48c.71.28,8.8.3,19.74.24,12.67.06,20.76,0,21.48-.24,1.54-.62,2.47-2.32,2.47-4.48s-1.7-6.79-1.7-11.73c0-4.07,3.35-25.3,4.53-32.67A1.85,1.85,0,0,0,230.08,295.94Zm-7.92,45.23c-.55.22-6.79.23-16.55.19-8.43,0-14.67,0-15.22-.19a3.45,3.45,0,0,1-1.9-3.42c0-1.65,1.31-5.18,1.31-8.95,0-.89-.21-2.85-.53-5.32l3.09,3.34a4.51,4.51,0,0,0,3.31,1.45h21.2A4.47,4.47,0,0,0,220,327l3.22-3.14c-.29,2.3-.48,4.11-.48,5,0,3.77,1.31,7.3,1.31,8.95A3.45,3.45,0,0,1,222.16,341.17Zm4.09-37.31c-.52,3.2-1.57,9.81-2.39,15.49l-3.13,1.91a11,11,0,0,1-5.73,1.61H197.78a11,11,0,0,1-5.59-1.53l-3.5-2.06c-.82-5.66-1.87-12.23-2.38-15.42a1.42,1.42,0,0,1,1.64-1.62,132.27,132.27,0,0,0,17.72,1.39,138.31,138.31,0,0,0,19-1.39A1.42,1.42,0,0,1,226.25,303.86Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "109.06 264.37 109.06 256.04 120.94 256.04 120.94 264.99 109.06 264.37",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.19,245.39s-1.85-.47-1.85,2.47,2.47,4.93,3.39,4.78-.46-5.71-.61-6.79S103.19,245.39,103.19,245.39Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.35,245.39s1.86-.47,1.86,2.47-2.47,4.93-3.4,4.78.46-5.71.62-6.79S126.35,245.39,126.35,245.39Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.37,230.72s-5.25.77-7.41,5.4-.61,11.12.16,14.82,3.86,7.26,6.17,8,9.42,0,9.42,0a27,27,0,0,0,4.48-6c2.16-3.86,2.47-11.12,1.54-15.28s-4.17-8.34-6.64-8.65-4.78,2-4.78,2A4.38,4.38,0,0,0,111.37,230.72Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.64,262.83s-9-1.39-13-.77-6.48,5.55-6.48,5.55a37.06,37.06,0,0,1,10-1.54,121.63,121.63,0,0,1,12.5.93A14.1,14.1,0,0,0,122.64,262.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.84,277.49S71.83,304.34,71.4,307s2.18,6.55,6.76,6.11,21.6-.65,21.6-.65l.21-4.15-13.74-1.74L94.52,300Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.23,
    y1: 306.52,
    x2: 79.47,
    y2: 309.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.17,276.41s17.22,27.93,17.66,30.54-2.18,6.55-6.77,6.11-21.59-.65-21.59-.65l-.22-4.15L144,306.52,135.7,300Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.99,
    y1: 306.52,
    x2: 150.76,
    y2: 309.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.13,265.14l-10.5,5.56c-5.24,2.78-8.49,5.4-8.79,6.79s5.86,45.39,5.86,45.39,4,3.9,14.51,4.94c15.75,1.54,22.54-3.4,22.54-3.4s9.42-46.31,9.42-48S129.28,269,125.11,267,116.31,263.29,108.13,265.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.75 335.69 104.12 394.4 109.21 393.79 101.65 334.3 85.75 335.69",
    style: {
      fill: "#D175F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.12,394.4l1.2,6.71a1.09,1.09,0,0,0,1.21.88l3.73-.48a1.08,1.08,0,0,0,.89-1.39l-1.94-6.33Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.38 335.69 124.01 394.4 118.92 393.79 126.48 334.3 142.38 335.69",
    style: {
      fill: "#D175F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,394.4l-1.2,6.71a1.09,1.09,0,0,1-1.21.88l-3.73-.48a1.08,1.08,0,0,1-.89-1.39l1.94-6.33Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.45,328.74S93.62,323.5,90.53,325s-6.17,5.56-5.09,10,10.34,9.88,12.35,10,12.81,0,12.81,0Z",
    style: {
      fill: "#D175F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.72,328.74s16.82-5.24,19.91-3.7,6.18,5.56,5.09,10-10.34,9.88-12.35,10-12.81,0-12.81,0Z",
    style: {
      fill: "#D175F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7,322.88s-1.39,15.44-.93,17.44,5.25,5.25,15,5.56,21.92.77,24.85-2.78-1.85-18.68-1.85-18.68S105.82,326.58,94.7,322.88Z",
    style: {
      fill: "#D175F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.48,401.29h0a1.08,1.08,0,0,1-1-1.16l3.16-58.38,3.64.3L95.64,400.3A1.08,1.08,0,0,1,94.48,401.29Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.72,401.29h0a1.08,1.08,0,0,0,1-1.16l-3.16-58.38-3.64.3,4.65,58.25A1.08,1.08,0,0,0,133.72,401.29Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.42,295.8a176.59,176.59,0,0,1-24.59,1.81,171.08,171.08,0,0,1-23-1.81,1.86,1.86,0,0,0-2.13,2.13c1.18,7.37,4.53,28.6,4.53,32.67,0,4.94-1.7,9.57-1.7,11.73s.93,3.86,2.47,4.48c.72.28,8.81.3,19.75.24,12.66.06,20.76,0,21.47-.24,1.54-.62,2.47-2.32,2.47-4.48s-1.7-6.79-1.7-11.73c0-4.07,3.35-25.31,4.53-32.68A1.84,1.84,0,0,0,137.42,295.8ZM129.5,341c-.55.21-6.79.23-16.56.19-8.43,0-14.66,0-15.21-.19a3.45,3.45,0,0,1-1.91-3.42c0-1.65,1.31-5.18,1.31-8.95,0-.89-.21-2.85-.53-5.32l3.09,3.34a4.53,4.53,0,0,0,3.31,1.45h21.2a4.47,4.47,0,0,0,3.15-1.29l3.23-3.14c-.3,2.3-.49,4.11-.49,5,0,3.77,1.31,7.3,1.31,8.95A3.45,3.45,0,0,1,129.5,341Zm4.08-37.31c-.51,3.2-1.57,9.81-2.39,15.49l-3.13,1.91a11,11,0,0,1-5.73,1.6H105.11a11,11,0,0,1-5.58-1.52L96,319.14c-.81-5.67-1.86-12.23-2.38-15.42a1.43,1.43,0,0,1,1.64-1.62A132.46,132.46,0,0,0,113,303.48a136.83,136.83,0,0,0,19-1.38A1.42,1.42,0,0,1,133.58,303.72Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 402,
    x2: 485,
    y2: 402,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC11);
export default __webpack_public_path__ + "static/media/c11.5dec12890d1d7f6984ba5c4aa538bc8a.svg";
export { ForwardRef as ReactComponent };